import styled from 'styled-components'

import { footer } from '../../styles/z-index.js'
import { black } from '../../styles/colors.js'
import { minmedia, maxmedia } from '../../styles/media-queries.js'

export const Wrapper = styled.div`
  position: relative;
  z-index: ${footer};
  background: ${props => (props.type ? 'none' : '#f6f6f6')}
  margin-top: ${props => (props.type ? 'auto' : '0')};
  padding: ${props => (props.type ? '1.5rem 1.5rem 0 1.5rem' : '1.25rem 1.5rem')};
  width: 100%;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  color: ${props => (props.type ? '#fff' : '#979797')}


  a {
    color: ${props => (props.type ? '#fff' : '#979797')}
  }
  ${maxmedia.xmlarge`
    margin-bottom: 56px;
  `};
  /* IE10 & IE11 */
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    margin-top: ${props => (props.type ? '2rem' : '0')};
  }
`

export const Link = styled.a`
  transition: all 0.5s;
  text-decoration: none;
  font-size: 14px;
  padding: 0 0.25rem;

  &:hover {
    color: ${black};
  }

  ${minmedia.medium`
    font-size: 16px;
  `};
`



// WEBPACK FOOTER //
// ./src/components/Footer/styles.js